module.exports = __webpack_public_path__ + "img/86048217.2df10fa1.png";